import { Component, Inject, OnInit, Input, Output, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import {ActivatedRoute, Router, NavigationExtras } from '@angular/router';

import { UploadOutput, UploadInput, UploadFile, humanizeBytes,
  UploaderOptions, UploadStatus } from 'ngx-uploader';

import { SchoolService } from '../../service/school.service';
import { UserManagementService } from '../../../../../tools/src/service/user.management.service';
import { MyErrorHandler } from '../../../../../projectmanagement/src/app/errorhandler/errorhandler';
import { TranslateService } from '@ngx-translate/core';

import { environment } from '../../../environments/environment';
import { Dialog } from '@eds/vanilla';
declare var jQuery;

@Component({
  selector: 'app-ctl-provision-schooluser',
  templateUrl: './ctl.provision.schooluser.component.html',
  styleUrls: ['./ctl.provision.schooluser.component.css'],
  providers: [SchoolService, UserManagementService]
})


export class ProvisionSchoolUserComponent implements OnInit {

  @Input() xlsFile = '';
  loadingPage = false;
  studentPreview = {};
  teacherPreview = {};
  xlsUserCount = 0;
  @Input() xlsStudentCount = 0;
  @Input() xlsTeacherCount = 0;
  @Input() xlsClassCount = 0;
  @Input() pageType = 'All';
  @Input() school_name:string;
  @Input() school_id:string;
  newClassFoundList = [];
  fileName;
  xlssample: any;
  samplewindow = '';
  nextBtnClicked = false;
  dataSampleLinkClicked = false;
  outputFileResponse: any;
  fileUploadStatus = 0;
  // ngx-uploader
  options: UploaderOptions;
  uploadFile: UploadFile;
  files: UploadFile[];
  uploadInput: EventEmitter < UploadInput > ;
  humanizeBytes: Function;
  dragOver: boolean;
  
  schoolDetails:any =[];
  url_path = 'fs/data/user/provision';

  @Output() uploadDone: EventEmitter<UploadOutput> = new EventEmitter();
  titleMessage: string;
  detailMessage1: string;
  detailMessage2: string;
  textDir:any;
  constructor(
    private schoolService: SchoolService,
    private userService: UserManagementService,
    public translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute) {
      this.textDir =  sessionStorage.getItem('textDir');
  }

  ngOnInit() {

    // ngx-uploader
    this.options = {
      concurrency: 1
    };
    this.files = [];
    this.uploadInput = new EventEmitter < UploadInput > ();
    this.humanizeBytes = humanizeBytes;
    this.nextBtnClicked = false;
    this.route.queryParams.subscribe(params => {
      //
    });
    this.resetUserProvision();
  }

  ngAfterViewInit() {
    //
  }

  enableLoadingPage() {
    this.loadingPage = true;
  }
  disableLoadingPage() {
    this.loadingPage = false;
  }

  excelUploadResponse() {
    console.log('uploader message');
    //alert("excelUpload")
    /*
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      //var responsePath = JSON.parse(response);
      console.log("***Excel response***:"+response);// the url will be in the response
      var previewList = JSON.parse(response);
      this.studentPreview = previewList.student;
      this.teacherPreview = previewList.teacher;
      this.excelUsersCount = previewList.userCount;
      this.excelStudentCount = previewList.totalStudents;
      this.excelTeacherCount = previewList.totalTeacher;
      this.parent.tempCollection = previewList.tempCollection;
      this.parent.tempLoginCollection = previewList.tempLoginCollection;
      this.fileName = previewList.fileName;
      //alert("response::"+response.teacher);
      //alert("this.studentPreview::"+this.studentPreview);
      //alert("this.teacherPreview::"+this.teacherPreview);

      jQuery('#largeModal').modal('show');
      };
      */
    }

  checkForNewClassesOld(){
    /*
    console.log('checkForNewClasses');
    jQuery('#largeModal').modal('hide');
    var params = {classes:[],tempCollection:""};
    params.classes = this.parent.sessionClasses;
    params.tempCollection = this.parent.tempCollection;

    this._setupyourschoolService.checkForNewClasses(params).subscribe(
       (response) => {
          console.log(response.length+" New class list : "+JSON.stringify(response));
          if(response.length<=0){
            //alert("Uploaded Successfully");
            jQuery('#successModal').modal('show');
            //jQuery('#newClassFoundModal').modal('show');
            //this.disableLoadingPage();

          }else{
            //alert("Additional class found in the system");
            this.newClassFoundList = response;
            jQuery('#newClassFoundModal').modal('show');
            this.disableLoadingPage();

          }
     },
     (err) => {
            console.log("ERROR: "+err);
     },
     () => {
            console.log("COMPLETED");
     }
    )
    */
  }
 
  openImportModal() {

  }

  importUser() {

  }

  cancelImport() {
    //
  }

  openNewClassModal() {

  }

  checkForNewClasses() {

  }

  addNewClass() {

  }

  ignoreNewClass() {

  }

  openSuccessModal() {
  }

  downloadTemplate() {
    let downloadAddStudentsAndTeachersTemplate = './assets/template/SchoolUserProvisionTemplate.xlsx';
    window.open(downloadAddStudentsAndTeachersTemplate);
  }

  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('bodyBG');
  }

  onUploadOutput(output: UploadOutput): void {
    if (output.type === 'allAddedToQueue') { // when all files added in queue
      // uncomment this if you want to auto upload files when added
      const event: UploadInput = {
        type: 'uploadAll',
        // school_id:this.school_id,
        url: environment.restAPI + this.url_path,
        headers: {
          Authorization: 'CTL ' + localStorage.getItem('token'),
          X_School_Id: this.school_id
        },
        method: 'POST'
      };
      this.uploadInput.emit(event);
      // this.loadingPage = true;
    } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') { // add file to array when added
      this.files.push(output.file);
    } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: UploadFile) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
      this.dragOver = false;
    } else if (output.type === 'drop') {
      this.dragOver = false;
    } else if (output.type === 'rejected' && typeof output.file !== 'undefined') {
      console.log(output.file.name + ' rejected');
    } else if (output.type === 'done') {
      if (output.file.responseStatus === 422){
        //alert("Inside error"+JSON.stringify(output.file.response.message));
        //File not uploaded
        //could not get role list
        //Check uploaded file
        //school not found
          if ( output.file.response.message === 'File not uploaded'){
            this.titleMessage = this.translate.instant('Import Failed');
          } else {
            this.titleMessage  = this.translate.instant('Invalid Excel Details');
          }
          this.detailMessage1 = this.translate.instant('Please check your excel document matches the template, and re-import.');
          if (this.pageType === 'TeacherOnly'){
            this.openDialogModal('errorModal2');
          } else{
            this.openDialogModal('errorModal1');
          }
      }
      // this.outputFileResponse=output.file.response;
      console.log('file upload status :' + output.file.responseStatus);
      if (output.file.responseStatus === 200) {
        // this.xlssample = output.file.response;
        this.xlsFile = output.file.name;
        // console.log("200 status");
        this.fileUploadStatus = output.file.responseStatus;
        this.uploadDone.emit(output);
      }
      // this.loadingPage = false;
    }
    this.files = this.files.filter(file => file.progress.status !== UploadStatus.Done);
  }
  cancelDelete(){
    // jQuery('#errorModal').modal('hide');
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id });
  }

  dataSampleLink(){
    this.dataSampleLinkClicked = true;
  }

  removeFile(id: string): void {
    this.uploadInput.emit({ type: 'remove', id });
  }

  removeAllFiles(): void {
    this.uploadInput.emit({
      type: 'removeAll'
    });
  }

  resetUserProvision() {
    //
    this.xlsFile = '';
    this.xlsStudentCount = null;
    this.xlsTeacherCount = null;
    this.xlsClassCount = null;
  }
  resetXlsFile() {
    //
    this.xlsFile = '';

  }
  openDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    console.log(dialog);
    dialog.init();
    dialog.show();
  }

  closeDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.hide();
  }
}

